import {
  AvailablePlansTypes,
  defaultAgencyPlan,
  defaultAutomatePlan,
  defaultCorePlan,
  defaultCreatePlan,
  defaultEnterprisePlan,
  defaultFreePlan,
  defaultLitePlan,
  defaultOldAgencyPlan,
  defaultProfessionalPlan,
  PLAN_NAMES
} from '@constants/plans'
import { useFeatureFlags } from '@contexts/featureFlags'
import { isPlanCheaper } from '@helpers/plans'
import { useState } from 'react'

import { useCheckoutContext } from '../routes/contexts'

export const useGetPlansList = () => {
  const { accountPlanRecordKey } = useCheckoutContext()

  const {
    FREE,
    LITE,
    PROFESSIONAL,
    AGENCY,
    ENTERPRISE,
    CORE,
    CREATE,
    AUTOMATE,
    AGENCY_OLD
  } = PLAN_NAMES

  const hasAccessToPricing2022 = useFeatureFlags('PRICING_2022')
  const hasAccessToFreePlanRestriction = useFeatureFlags(
    'FREE_PLAN_RESTRICTIONS'
  )

  const [professionalPlan, setProfessionalPlan] = useState<AvailablePlansTypes>(
    defaultProfessionalPlan
  )

  const [agencyPlan, setAgencyPlan] =
    useState<AvailablePlansTypes>(defaultAgencyPlan)

  const isHighlightedProfessionalPlan = !isPlanCheaper({
    plan1: professionalPlan,
    plan2: accountPlanRecordKey
  })

  const isHighlightedAutomatePlan = !isPlanCheaper({
    plan1: defaultAutomatePlan,
    plan2: accountPlanRecordKey,
    isOldPlan: true
  })

  const plans = {
    free: {
      name: FREE,
      recordKey: defaultFreePlan,
      isFreePlan: true
    },
    lite: {
      name: LITE,
      recordKey: defaultLitePlan
    },
    professional: {
      name: PROFESSIONAL,
      recordKey: professionalPlan,
      isHighlighted: isHighlightedProfessionalPlan,
      setPlanTypeName: setProfessionalPlan
    },
    agency: {
      name: AGENCY,
      recordKey: agencyPlan,
      setPlanTypeName: setAgencyPlan
    },
    enterprise: {
      name: ENTERPRISE,
      recordKey: defaultEnterprisePlan
    }
  }

  const oldPlans = {
    core: {
      name: CORE,
      recordKey: defaultCorePlan,
      isOldPlan: true
    },
    create: {
      name: CREATE,
      recordKey: defaultCreatePlan,
      isOldPlan: true
    },
    automate: {
      name: AUTOMATE,
      recordKey: defaultAutomatePlan,
      isHighlighted: isHighlightedAutomatePlan,
      isOldPlan: true
    },
    agencyOld: {
      name: AGENCY_OLD,
      recordKey: defaultOldAgencyPlan,
      isOldPlan: true
    }
  }

  const { free, lite, professional, agency, enterprise } = plans
  const { core, create, automate, agencyOld } = oldPlans

  const defaultPlans = [lite, professional, agency]

  if (hasAccessToPricing2022 && !hasAccessToFreePlanRestriction) {
    return [...defaultPlans, enterprise]
  }

  if (hasAccessToPricing2022 && hasAccessToFreePlanRestriction) {
    return [free, ...defaultPlans]
  }

  return [core, create, automate, agencyOld]
}
